<template>
  <chart-container
    :titleChart="titleChart"
    @onCSVDownload="downloadCsv(titleChart)"
    @zoomEnabled="zoomGraph(true)"
    @zoomDisabled="zoomGraph(false)"
    :downloadId="downloadId"
    :specificSiteId="specificSiteId"
    :zoomGraphValue="zoomGraphValue"
    :downloadShow="this.nullexpected"
    class="bg-gradient-blue"
    titleTooltip="This chart shows the discontinuation reasons for participants in this study and orders them from the most common reason to the least common reason. Hovering over each bar will show the number of participants who have discontinued for that reason. If multiple discontinuation reasons were selected for a single participant, then each reason will display on the chart, so the totals may add up to a higher number than the amount of participants who have discontinued."
    :tooltipHtmlContent="true"
    tooltipPlacement="bottom"
    :showThreadLogoInUnexpand="this.nullexpected"
  >
    <fusioncharts style="width: 100%" :type="type" :width="width" :height="height" :dataFormat="dataFormat" :dataSource="dataSource" dataEmptyMessage="No Data In" ref="siteDataPerformanceOverTime" v-if="this.nullexpected" slot="body" />
    <div slot="body" class="text-left min-height-0" v-if="this.nullexpected"></div>
    <div v-else class="align-center p-60" slot="body">
      <div class="card-text-title no-data-down">No Data In</div>
    </div>
  </chart-container>
</template>

<script>
import ChartContainer from "./chart-container-dark-blue";
import * as dManagement from "@/services/visualization/study-completion";
import _cloneDeep from "lodash/cloneDeep";
import { downloadCSV } from "../../services/visualization/data-management";
export default {
  components: {
    ChartContainer
  },

  props: {
    titleChart: { type: String, default: "" },
    downloadId: { type: String, default: "" },
    zoomGraphValue: { type: String, default: "" },
    specificSiteId: [Object, Array],
    countrySelected: [Array, String],
    sitesSelected: [Array, String],
    rawData: { type: [Object, Array], default: () => {} },
    dataLoaded: { type: Boolean, default: false },
    participantsSelected: [Array, String]
  },
  data() {
    return {
      checkrawdata: null,
      zoomGraphValueChild: "",
      nullexpected: null,
      zoomTrigger: false,
      type: "bar2d",
      width: "100%",
      height: "250",
      dataFormat: "json",
      dataSource: {
        chart: {
          yAxisName: "Number of Participants",
          xAxisName: "Discontinuation Reasons",
          palettecolors: "#A692F3",
          plottooltext: "$label{br}$value Participants",
          theme: "fusion",
          xAxisNameFontColor: "#fffff",
          xAxisNameFont: "RobotoRegular",
          xAxisNameFontSize: "9px",
          labelFont: "RobotoRegular",
          labelFontColor: "#fffff",
          yAxisNameFontColor: "#fffff",
          yAxisNameFont: "RobotoRegular",
          yAxisNameFontSize: "9px",
          yAxisValueFont: "RobotoRegular",
          yAxisValueFontSize: "10px",
          yAxisValueFontColor: "#fffff",
          useEllipsesWhenOverflow: "1",
          maxColWidth: "42",
          plotHighlightEffect: "fadeout",
          plotSpacePercent: 30,
          reverseLegend: true,
          minimiseWrappingInLegend: true,
          showXAxisLine: true,
          showYAxisLine: true,
          xaxislinethickness: "1",
          yaxislinethickness: "1",
          xAxisLineColor: "#b0bac9",
          yAxisLineColor: "#b0bac9",
          chartBottomMargin: "0",
          xAxisNamePadding: "5",
          decimals: 3,
          numvisibleplot: 0,
          trendvaluefontsize: "10",
          trendvaluefontcolor: "fffff",
          bgAlpha: "0",
          minLabelHeight: "5",
          scrollBar2D: "5"
        },
        data: []
      }
    };
  },
  watch: {
    zoomGraphValue: function(newVal) {
      this.zoomGraphValueChild = newVal;
      if (newVal == "") {
        this.height = "250";
      }
      if (newVal) {
        this.zoomTrigger = true;
      } else {
        this.zoomTrigger = false;
      }
    },
    rawData: function(newVal) {
      const response = dManagement.getsitesiteDiscontinuationActivity(newVal, this.countrySelected, this.sitesSelected);
      this.checkrawdata = newVal;
      this.setGraphDataAndConfigsf(response);
      if (Object.keys(newVal).length > 0) {
        this.nullexpected = true;
      } else {
        this.nullexpected = false;
      }
    },
    sitesSelected: function(newVal) {
      const response = dManagement.getsitesiteDiscontinuationActivity(this.rawData, this.countrySelected, newVal);
      this.setGraphDataAndConfigsf(response);
    },
    participantsSelected: function(newVal) {
      const localraw = this.checkrawdata;
      if (newVal.length > 0 && Object.keys(localraw).length > 0) {
        this.nullexpected = true;
      } else {
        this.nullexpected = false;
      }
    }
  },
  methods: {
    zoomGraph(status) {
      if (status) {
        this.zoomGraphValueChild = true;
        this.height = "400";
        this.$emit("zoomEnabled");
      } else {
        this.zoomGraphValueChild = false;
        this.height = "250";
        this.$emit("zoomDisabled");
      }
    },
    downloadCsv(titleChart) {
      setTimeout(() => {
        const header = ["Discontinuation Reasons", "No. of Participants"];
        const newArr = [];
        const response = dManagement.getsitesiteDiscontinuationActivity(this.rawData, this.countrySelected, this.sitesSelected);
        response.csvData.map(item => newArr.push([item.label, item.value]));
        downloadCSV(titleChart, header, newArr, this.specificSiteId);
      }, 1);
    },
    getNumVisPlotByZoom() {
      let numVisPlot = 0;
      switch (this.curZoomLevel) {
        case 0:
          numVisPlot = this.zoomTrigger ? 8 : 4.2;
          break;
        case 1:
          numVisPlot = this.zoomTrigger ? 7 : 3.2;
          break;
        case 2:
          numVisPlot = this.zoomTrigger ? 6 : 2.2;
          break;
        default:
          break;
      }
      return numVisPlot;
    },
    zoomInChart() {
      if (this.curZoomLevel < this.maxZoomLevel) {
        this.curZoomLevel = this.curZoomLevel + 1;
        const chartRef = this.$refs.siteDataPerformanceOverTime.chartObj;
        const data = chartRef.getJSONData();
        const numVisPlot = this.getNumVisPlotByZoom();
        data.chart.bubblescale = numVisPlot;
        chartRef.setJSONData(data);
      }
    },
    zoomOutChart() {
      if (this.curZoomLevel > 0) {
        this.curZoomLevel = this.curZoomLevel - 1;
        const chartRef = this.$refs.siteDataPerformanceOverTime.chartObj;
        const data = chartRef.getJSONData();
        const numVisPlot = this.getNumVisPlotByZoom();
        data.chart.bubblescale = numVisPlot;
        chartRef.setJSONData(data);
      }
    },
    setGraphDataAndConfigsf(response = null) {
      if (response.csvData.length > 0) {
        this.nullexpected = true;
      } else {
        this.nullexpected = false;
      }
      const dataSources = _cloneDeep(this.dataSource);
      dataSources.chart.labelFontSize = response.data;
      dataSources.data = response.csvData;
      this.dataSource = dataSources;
    }
  }
};
</script>

<style lang="scss">
.bg-gradient-blue {
  .fusioncharts-container > svg {
    background-color: unset !important;
  }
}
</style>
